// @ts-nocheck
import { HtmlClassSwitch, DomQuery } from "./Dom";
import { Enumeration } from "./Enumeration";
import { distributeEvent, DataChangedEvent, distributeEventDownHierarchy, CountChangedEvent, getEvent } from "./Event";
import { HttpClient } from "./Http.Client";
import { application } from "./WebApp.Instance";

export var RefreshMode = new Enumeration(["OnRequest", "ForSiblings", "Recurring"]);
export var RenderScope = new Enumeration(["None", "Toolbar", "Body", "Component", "Complete"]);
export var ControlMode = new Enumeration(["display", "edit"]);

function maximumRenderScope(left, right) {
  if (left === RenderScope.Complete || right === RenderScope.Complete)
    return RenderScope.Complete;
  if (left === RenderScope.Component || right === RenderScope.Component)
    return RenderScope.Component;
  else if (left === RenderScope.Body || right === RenderScope.Body)
    return RenderScope.Body;
  else if (left === RenderScope.Toolbar || right === RenderScope.Toolbar)
    return RenderScope.Toolbar;
  else
    return RenderScope.None;
}

export function ComponentWithName(name) {
  return function (component) { return component.element.dataset.HierarchicalName === name; }
}

export function ComponentWithClass(class_) {
  return function (component) { return component instanceof class_; }
}

export class WebPageComponent {
  constructor(element) {
    this.element = element;
    this.visible = true;
    this.valid = true;
    this.client = new HttpClient();
    this.onSelectionChanged = null;
    this.parentComponent = null;
    this.childComponents = new Array();
    this.updatingCounter = null;
    this.determineProperties();
  }

  createToggleButton(element, subject, class_) {
    element.onclick = (event) => {
      var classSwitch = new HtmlClassSwitch(subject, class_);
      classSwitch.toggle();

      if (!classSwitch.getStatus())
        subject.clickOutsideListener = connectClickOutsideListener(subject, (event) => { element.onclick(event) })
      else if (subject.clickOutsideListener !== undefined)
        removeClickOutsideListener(subject.clickOutsideListener);
    }
  }

  determineProperties() {
    if (this.element.dataset.RefreshMode !== undefined) {
      this.refreshMode = RefreshMode.fromText(this.element.dataset.RefreshMode);

      if (this.refreshMode === RefreshMode.Recurring) {
        this.refreshInterval = this.element.dataset.RefreshInterval;

        this.refreshProcessId = window.setInterval(
          () => {
            if (document.body.contains(this.element))
              this.refresh();
            else
              window.clearInterval(this.refreshProcessId);
          },
          this.refreshInterval
        );
      }
    }

    if (this.element.dataset.Mode !== undefined)
      this.mode = ControlMode.fromText(this.element.dataset.Mode);
    else
      this.mode = ControlMode.edit;
  }

  fireDataChanged() {
    distributeEvent(new DataChangedEvent(this));
  }

  fireSelectionChangedEvent() {
    if (this.onSelectionChanged !== null)
      this.onSelectionChanged(this);
  }

  focus() {
  }

  isFocusable() {
    return this.mode === ControlMode.edit;
  }

  getValue() {
    console.warn("getValue not implemented for: " + this.constructor.name);
    return null;
  }

  setValue() {
    console.warn("setValue not implemented for: " + this.constructor.name);
  }

  getPublishedActions() {
    return [];
  }

  collectPublishedActions() {
    return [];
  }

  getAncestor(condition) {
    let result = null;
    let current = this;

    while (result === null && current !== null) {
      if (condition(current))
        result = current;
      else
        current = current.parentComponent;
    }

    return result;
  }

  getDescendant(condition) {
    const components = this.getDescendants(condition);

    if (components.length > 0)
      return components[0]
    else
      return null;
  }

  getDescendants(condition) {
    let query = new DomQuery(this.element);
    let elements = query.getDescendants((element) => {
      return element.component !== undefined && condition(element.component)
    });

    let result = new Array();

    for (const element of elements)
      result.push(element.component);

    return result;
  }

  bind() {
  }

  release() {
  }

  load(value) {
    for (const property in value) {
      const child = this.childComponents.find(element => element.name === property);

      if (child && child.mode === ControlMode.edit)
        child.load(value[property]);
    }
  }

  save() {
    const result = {};

    for (const component of this.childComponents) {
      if (component.mode === ControlMode.edit && component.name)
        result[component.name] = component.save();
    }

    return result;
  }

  invalidate() {
    this.valid = false;
    setTimeout(() => { this.revalidate(); }, 0);
  }

  async validate() {
  }

  async revalidate() {
    if (this.canValidate()) {
      await this.validate();
      this.valid = true;
      distributeEventDownHierarchy(new ComponentValidatedEvent(this), this);
    }
  }

  canValidate() {
    return (this.parentComponent === null || (this.parentComponent.valid && this.parentComponent.canValidate()));
  }

  handleEvent(event) {
    if (event instanceof CountChangedEvent)
      event.handled = true;
    else if (event instanceof ComponentValidatedEvent && !this.valid)
      this.revalidate();
  }

  addEventListener(event, handler) {
    // Override in specific descendants when the root element is not an input element
    this.element.addEventListener(event, handler);
  }

  refresh() {
  }
}

export function connectClickOutsideListener(element, callback) {
  return new ClickOutsideListener([element], callback);
}

export function removeClickOutsideListener(listener) {
  listener.remove();
}

export class ClickOutsideListener {
  constructor(elements, callback) {
    this.elements = elements;
    this.callback = callback;

    this.connect();
  }

  contains(source) {
    const query = new DomQuery(source);
    return this.elements.some((element) => query.hasAncestor(element));
  }

  connect() {
    this.listener = (event) => {
      const source = getEvent(event).getSource();

      if (!this.contains(source) && this.shouldHandle())
        this.callback(event);
    };

    const htmlElement = document.getElementsByTagName("html")[0];
    htmlElement.addEventListener(
      "click",
      this.listener,
      true
    );
  }

  shouldHandle() {
    // TODO: This models a modal/overlay stack. However, especially with the introduction of support for multiple elements in this listener,
    //       we should probably refactor to remove the dependency on application.pageHandler.getPopUps() and instead properly represent these overlay layers.
    const popUps = application.pageHandler.getPopUps();
    return (popUps.length === 0) || this.elements.some((element) => popUps[popUps.length - 1].contains(element));
  }

  remove() {
    const htmlElement = document.getElementsByTagName("html")[0];
    htmlElement.removeEventListener("click", this.listener, true);
  }
}

export class Labels {
  constructor(element) {
    this.element = element;

    const labels = element.querySelectorAll('[data--identifier]');

    labels.forEach(label => {
      const key = label.getAttribute('data--identifier');
      this[key] = label;
    });
  }
}

export class ComponentValidatedEvent {
  constructor(component) {
    this.component = component;
  }
}
